<template>
    <div class="DontGetAnswer-Wrap" id="kontaktny-formular">
        <div class="DontGetAnswer-WrapHeadline">
            <div class="DontGetAnswer-Wrap-HeadlineWrap">
                <h2 v-if="!is_feedback">{{ i18n.nenasli_ste_odpoved }}</h2>
                <h2 v-else>{{ i18n.spravme_envishop_lepsim }}</h2>
            </div>
        </div>
        <div class="DontGetAnswerWrapForm">
            <form class="DontGetAnswer__form" @submit.prevent="contact()">
                <div class="columns is-multiline">
                    <div class="column is-half">
                        <input type="text" v-model="name" :placeholder="i18n.vase_meno + ' *'">
                    </div>
                    <div class="column is-half">
                        <input type="text" v-model="email" :placeholder="i18n.vas_email + ' *'">
                    </div>
                    <div class="column is-full">
                        <textarea :placeholder="is_feedback ? i18n.povedztne_nam_o_vasej_skusenosti + ' *' : i18n.otazka + ' *'"
                                  v-model="question" cols="30" rows="5"></textarea>
                    </div>
                    <div class="column is-full" v-if="!is_feedback">
                        <label>
                            <input type="checkbox" v-model="gdpr"> &nbsp; {{ i18n.suhlasim_so }} <a
                            class="orange-link" href="/vseobecne-podmienky-spoluprace" target="_blank">{{ i18n.spracovanim_osobnych_udajov }}</a> {{ i18n.pre_ucel_odoslania_odpovede_na_tento_formular }}
                        </label>
                    </div>
                    <input type="hidden" name="is_feedback" value="1" v-if="is_feedback">
                    <input type="hidden" name="is_feedback" value="0" v-else>
                    <div class="column is-full">
                        <div class="DontGetAnswer__form-buttonWrap">
                            <button class="button " type="submit">{{ buttonMessage }}</button>
                        </div>
                    </div>
                </div>
            </form>
            <p class="text-center"><br>{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: false
        },
        is_feedback: {
            type: Boolean,
            required: false
        },
        logged_in_name: String,
        logged_in_email: String,
        contactRoute: String
    },
    data: function () {
        return {
            name: this.logged_in_name,
            email: this.logged_in_email,
            question: null,
            message: null,
            gdpr: this.is_feedback,
            i18n: i18n,
            buttonMessage: ''
        };
    },
    created() {
        if (this.url !== '') {
            this.question =  this.i18n.chyba_sa_nachadza_v_tomto_clanku + ' ' + this.url;
        }

        this.buttonMessage = this.is_feedback ? this.i18n.odoslat_nazor : this.i18n.odoslat_otazku;
    },
    methods: {
        contact: function () {
            this.buttonMessage = this.i18n.nacitavam
            this.message = null;
          console.log(this.contactRoute);

            axios
                .post(this.contactRoute, {
                    name: this.name,
                    email: this.email,
                    question: this.question,
                    gdpr: this.gdpr,
                    is_feedback: this.is_feedback
                })
                .then(response => {
                    this.message = this.i18n.dakujeme_za_spravu_coskoro_vas_budeme_kontaktovat
                    this.name = null
                    this.email = null
                    this.question = null
                    this.gdpr = this.is_feedback
                })
                .catch(error => {
                    this.message = this.i18n.nevyplnili_ste_vsetky_povinne_polia_spravne
                })
                .finally(() => this.buttonMessage = this.is_feedback ? this.i18n.odoslat_nazor : this.i18n.odoslat_otazku)
        }
    }
};
</script>
